import { MDCCircularProgress } from '@material/circular-progress'

export default {
  setup() {
    this.circularProgress = new MDCCircularProgress(this.el)
  },
  destroy() {
    this.circularProgress?.destroy()
    this.circularProgress = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
